import React from 'react'
import './MyNavBar.css'
import { Icon } from 'antd-mobile'
export default function MyNavBar (props) {
  const leftContentVisible = props.leftContentVisible === false ? props.leftContentVisible : true // 是否显示左侧图标，默认为false
  const rightContentVisible = props.rightContentVisible === false ? props.rightContentVisible : true // 是否显示右侧图标，默认为false
  return (
    <div style={props.style || {}} className={'navBar'}>
      <div className={'leftContent'} onClick={props.leftClick || props.history.goBack}>
        {!leftContentVisible ? null : props.Icon ? props.Icon : <Icon size={'lg'} color={'white'} type={'left'} />}
      </div>
      <div style={props.titleStyle || {}} className={'titleContent'}>{props.children}</div>
      <div className={'rightContent'} onClick={props.rightClick || props.history.goBack}>
        {!rightContentVisible ? null : props.rightContent ? props.rightContent : <Icon size={'lg'} color={'white'} type={'cross'} />}
      </div>
    </div>
  )
}
